export default __webpack_public_path__ + "static/media/logo_white.341cd1b9.gif";